import { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useKeenSlider } from 'keen-slider/react';
import Video from 'react-scale/components/elements/video';

import 'keen-slider/keen-slider.min.css';
import { WheelControls } from 'react-scale/lib/keen-slider';
import style from './video-gallery.module.css';

const DiveIn = ({ showParagraphUnderVideo = true, videos }) => {
  const [selectedVideo, setSelectedVideo] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [cursor, setCursor] = useState('grab');

  const [sliderRef, slider] = useKeenSlider(
    {
      rubberband: false,
      created() {
        setLoaded(true);
      },
      dragStarted: () => {
        setCursor('grabbing');
      },
      dragEnded: () => {
        setCursor('grab');
      },
      breakpoints: {
        '(min-width: 0px) and (max-width: 639px)': {
          slides: {
            perView: 1,
            spacing: 32
          },
          mode: 'snap',
          slideChanged(_slider) {
            setCurrentSlide(_slider.track.details.rel);
          },
          centered: true
        },
        '(min-width: 640px) and (max-width: 767px)': {
          slides: {
            perView: 2,
            spacing: 32
          },
          mode: 'free',
          slideChanged(_slider) {
            setCurrentSlide(_slider.track.details.rel);
          }
        },
        '(min-width: 768px) and (max-width: 1040px)': {
          slides: {
            perView: 3.1,
            spacing: 32
          },
          mode: 'snap',
          slideChanged(_slider) {
            setCurrentSlide(_slider.track.details.rel);
          }
        },
        '(min-width: 1041px)': {
          slides: {
            perView: 3,
            spacing: 32
          },
          mode: 'snap',
          slideChanged(_slider) {
            setCurrentSlide(_slider.track.details.rel);
          }
        }
      }
    },
    [WheelControls]
  );

  return (
    <div className={style.section}>
      <div className="relative mb-12 space-y-16 sm:mb-0">
        {videos?.map((video, index) => {
          if (video.src === videos[selectedVideo].src) {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <div className={style.fadeIn} key={index}>
                <Video
                  blackButton
                  className="hidden mb-7 sm:block"
                  url={videos[selectedVideo].src}
                  poster={video.cover}
                />
              </div>
            );
          }
        })}
        {showParagraphUnderVideo && (
          <p className="hidden sm:block">{videos[selectedVideo].paragraph}</p>
        )}
        <div ref={sliderRef} style={{ cursor }} className="keen-slider !overflow-visible">
          {videos?.map((video, index) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              className={cn(
                selectedVideo !== index && 'sm:opacity-50',
                'cursor-pointer transition-opacity duration-300 keen-slider__slide !overflow-visible opacity-100 space-y-12 sm:space-y-7'
              )}
            >
              <div
                className={cn(
                  selectedVideo === index ? style.gradientBox : 'sm:border-[1px] border-transparent'
                )}
              >
                <div onClick={() => setSelectedVideo(index)}>
                  <div className="absolute inset-0 z-10 hidden sm:block" />
                  <Video
                    blackButton
                    poster={video.cover}
                    url={video.src}
                    smallButton
                    width={384}
                    height={235}
                  />
                </div>
              </div>
              <p className="max-w-xs mx-auto text-center text-white sm:text-left sm:max-w-none">
                {video.paragraph}
              </p>
              <p className="max-w-xs mx-auto text-center text-neutral-400 sm:text-left sm:max-w-none">
                {video.body}
              </p>
            </div>
          ))}
        </div>
      </div>
      {loaded && slider && (
        <div className="flex justify-center mx-auto space-x-2 max-w-max sm:hidden">
          {[...Array(slider.current.slides.length).keys()]?.map(idx => (
            <span
              key={idx}
              onClick={() => slider.current?.moveToIdx(idx)}
              className={cn(
                'cursor-pointer rounded-full w-[10px] h-[10px]',
                currentSlide === idx ? 'bg-white' : 'bg-[#37383B]'
              )}
            />
          ))}
        </div>
      )}
    </div>
  );
};

DiveIn.propTypes = {
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      cover: PropTypes.string,
      paragraph: PropTypes.string
    })
  )
};

DiveIn.defaultProps = {
  videos: [
    {
      src: 'https://scaleai.wistia.com/medias/ieikkjioxr',
      cover: '/static/images/pages/document/covers/dive-in/first.png',
      paragraph: 'Upload documents, receive labeled structured data, and curate results.'
    },
    {
      src: 'https://scaleai.wistia.com/medias/u3mmx1zoku',
      cover: '/static/images/pages/document/covers/dive-in/second.png',
      paragraph: 'Flexport relies on Scale Document AI to process logistics documents.'
    }
  ]
};

export default DiveIn;
